import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
// import { initializeApp } from "firebase/app";
// import {getAuth} from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQQlRnoaKRQZc73JRhAsZx07c74HkWiqw",
  authDomain: "fir-57a58.firebaseapp.com",
  projectId: "fir-57a58",
  storageBucket: "fir-57a58.appspot.com",
  messagingSenderId: "646270289447",
  appId: "1:646270289447:web:7c78097ee5633a825d7002",
  measurementId: "G-TTE5RFS49K"
};
// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const auth=firebase.auth()
const db=app.firestore()
export {auth,db};
